import { getApps, initializeApp } from 'firebase/app';
import { confirmPasswordReset, getAuth, verifyPasswordResetCode } from 'firebase/auth';

const fallbackConfig = {
  apiKey: 'AIzaSyBuC6K5G4nRNjOwT9nSSJ4Jkph74OW6UXM',
  authDomain: 'tailorwalaapp-81042.firebaseapp.com',
  projectId: 'tailorwalaapp-81042',
};

export const RESET_PASSWORD_PAGE = 'reset-password';

function getResetAppName(apiKey) {
  return `tailorwala-reset-${apiKey.slice(-8)}`;
}

function getResetAuthClient(apiKey, lang = 'en') {
  const effectiveApiKey = apiKey || fallbackConfig.apiKey;
  const appName = getResetAppName(effectiveApiKey);
  const existingApp = getApps().find((item) => item.name === appName);
  const app =
    existingApp ??
    initializeApp(
      {
        ...fallbackConfig,
        apiKey: effectiveApiKey,
      },
      appName,
    );

  const auth = getAuth(app);
  auth.languageCode = lang || 'en';
  return auth;
}

export function parseResetQuery(search) {
  const params = new URLSearchParams(search);

  return {
    apiKey: params.get('apiKey') || fallbackConfig.apiKey,
    continueUrl: params.get('continueUrl') || '',
    lang: params.get('lang') || 'en',
    mode: params.get('mode') || '',
    oobCode: params.get('oobCode') || '',
  };
}

export async function verifyResetLink(state) {
  const auth = getResetAuthClient(state.apiKey, state.lang);
  return verifyPasswordResetCode(auth, state.oobCode);
}

export async function submitPasswordReset(state, nextPassword) {
  const auth = getResetAuthClient(state.apiKey, state.lang);
  return confirmPasswordReset(auth, state.oobCode, nextPassword);
}

export function getSafeContinueUrl(rawUrl) {
  if (!rawUrl) {
    return '/';
  }

  try {
    const parsedUrl = new URL(rawUrl, window.location.origin);

    if (parsedUrl.origin !== window.location.origin) {
      return '/';
    }

    return `${parsedUrl.pathname}${parsedUrl.search}${parsedUrl.hash}` || '/';
  } catch (error) {
    return '/';
  }
}
